define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/documentElement.js
// module id = 551
// module chunks = 349